(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2901],{

/***/ 25986:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shivsway",
      function () {
        return __webpack_require__(10220);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_shivsway; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/layout/layout.tsx + 22 modules
var layout = __webpack_require__(16559);
;// CONCATENATED MODULE: ./src/assets/images/shivsway-banner.jpg
/* harmony default export */ var shivsway_banner = ({"src":"/_next/static/media/shivsway-banner.f64ac37b.jpg","height":400,"width":1263,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAcEAABBQEBAQAAAAAAAAAAAAABAAIDBBEhEjH/xAAVAQEBAAAAAAAAAAAAAAAAAAACA//EABYRAAMAAAAAAAAAAAAAAAAAAAABMf/aAAwDAQACEQMRAD8AkzcsSsqRvmcR5Dt3ulwB79REQUKun//Z"});
// EXTERNAL MODULE: ./src/styles/kishalaya.module.scss
var kishalaya_module = __webpack_require__(77645);
var kishalaya_module_default = /*#__PURE__*/__webpack_require__.n(kishalaya_module);
;// CONCATENATED MODULE: ./src/pages/shivsway.tsx



swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl,
    swiper_esm/* Autoplay */.pt
]);




var shivsway = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (kishalaya_module_default()).csr_banner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: shivsway_banner,
                    alt: "",
                    width: 1920,
                    height: 608
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (kishalaya_module_default()).table,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pt-5 w-100",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    colSpan: 2,
                                                    className: (kishalaya_module_default()).tab_h,
                                                    children: "Project-Shivsway"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "Our accreditation partner whom SHIVSWAY is affiliated with to run its courses"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: (kishalaya_module_default()).w_50,
                                                        children: "Paschim Banga Society For Skill Development ( PBSSD) which works under the Dept. of Technical Education, Training & Skill Development of W.B"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "Functional Areas on which the training is being imparted"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: (kishalaya_module_default()).w_50,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "CAD – Jewellery Designer"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "Jewellery Retail sales Associate"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "Total number of Beneficiaries brought under the training on CAD- Jewellary Designer"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: (kishalaya_module_default()).w_50,
                                                        children: "40"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "Total number of Beneficiaries brought under the training on Jewellary Retail Sales Associate"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: (kishalaya_module_default()).w_50,
                                                        children: "40"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        children: "Number Of Students Below Poverty Line who have undergone the training with us"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                        className: (kishalaya_module_default()).w_50,
                                                        children: "22"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                className: "mt-5 ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Total Number of students who have successfully completed their paid internship at Senco Gold & Diamond Stores across multiple locations"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: (kishalaya_module_default()).w_50,
                                                    children: "17"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Total number of students who have got placed in Jewelry Retail Sector"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: (kishalaya_module_default()).w_50,
                                                    children: "13"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Total number of students who have got placed in Apparel, Fashion & Lifestyle Sector"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: (kishalaya_module_default()).w_50,
                                                    children: "4"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Total number of students who have got placed in Food & Beverage/ Quick Restaurant Chain"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: (kishalaya_module_default()).w_50,
                                                    children: "7"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Total number of students who have got placed in Tele-sales & Front Office"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: (kishalaya_module_default()).w_50,
                                                    children: "7"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Total number of students who have got placed in Footwear Retail"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: (kishalaya_module_default()).w_50,
                                                    children: "1"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Total number of students who have got placed in Telecommunication & Mobile Network Service"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: (kishalaya_module_default()).w_50,
                                                    children: "5"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    children: "Total number of students placed so far in a full time job"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: (kishalaya_module_default()).w_50,
                                                    children: "37"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var pages_shivsway = (shivsway);


/***/ }),

/***/ 77645:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tab_h":"kishalaya_tab_h__Q0wbr","table":"kishalaya_table__Xvlyg","w_50":"kishalaya_w_50__9z9Xj"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8523,4766,5675,9915,2640,3913,536,486,6646,1251,9774,2888,179], function() { return __webpack_exec__(25986); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);